module.exports = __webpack_public_path__ + "static/media/lite.01dd575f.jpg";